import { render, staticRenderFns } from "./CenteredContainer.vue?vue&type=template&id=5d266cee&scoped=true&"
import script from "./CenteredContainer.vue?vue&type=script&lang=js&"
export * from "./CenteredContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d266cee",
  null
  
)

export default component.exports